<template>
  <div data-grm-comp="RoomCBTLogUser" class="room-cbt-modal-component">
    <div class="room-cbt-modal flex flex-col">
      <div class="room-cbt-header">
        <h6>출제 이력 사용자 제출 결과</h6>
        <GrmCloseBtn @click="onClose"/>
      </div>
      <div class="mt-6 min-h-0 flex-1 overflow-y-auto">
        <p class="text-2xl font-bold">{{ cbtLog.roomCbtTitle }}</p>
        <RoomCBTLogUserInfo class="mt-4" />
        <RoomCBTLogUserResult class="mt-4" :roomCbtUser="roomCbtUser" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import RoomCBTLogUserInfo from "@/components/Room/CBT/RoomCBTLogUserInfo.vue";
import RoomCBTLogUserResult from "@/components/Room/CBT/RoomCBTLogUserResult.vue";

export default {
  name: 'RoomCBTLogUser',
  components: {
    GrmCloseBtn,
    RoomCBTLogUserInfo,
    RoomCBTLogUserResult,
  },
  computed: {
    ...mapState('cbt', [
      'cbtLog',
    ]),
    ...mapGetters('cbt', [
      'getRoomCBTLog',
      'getCBTLogUserQuestionList',
    ]),

    roomCBTLog() {
      return this.getRoomCBTLog(this.cbtLog.roomCbtId)
    },
    roomCbtUser() {
      return this.$parent.roomCbtUser
    },
    number() {
      return (i) => {
        if (i < 10) return `00${i}`
        if (i < 100) return `0${i}`
        return i
      }
    },
  },
  created() {
    console.log(this.roomCBTLog)
  },
  methods: {
    onClose() {
      this.$modal('RoomCBTLogUser')
    },
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-modal-component {
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 4;
  white-space: pre-line;
}

.room-cbt-modal {
  position: relative;
  width: 960px;
  height: 90vh;
  padding: 30px 30px 50px 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.room-cbt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h6 {
    font-size: 18px;
    font-weight: bold;
  }
}

// Mobile
[grm-device-mobile] {
  .room-cbt-modal-component {
    left: 0;

    .room-cbt-modal {
      width: 100%;
      height: 100%;
      max-height: none;
      border-radius: 0;

      .room-cbt-contents {
        height: calc(100% - 50px);
      }
    }
  }
}
</style>